module.exports = __webpack_public_path__ + "images/Notification_771bb81.png";